var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGenderSignFemale = function SvgGenderSignFemale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 242.2 242.2",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E852",
    d: "M119 0C72 1.2 34.8 40.2 36 87.2c1 41 31.1 75.5 71.6 82v23.2h-8.2c-7.4 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5h8.2v9.4c0 7.4 6 13.5 13.5 13.5 7.4 0 13.5-6 13.5-13.5v-9.4h8.2c7.4 0 13.5-6 13.5-13.5s-6-13.5-13.5-13.5h-8.2v-23.2c41.2-6.7 71.5-42.3 71.7-84.1 0-47-38.1-85.1-85.1-85.1zm61.5 85.1c0 32.8-26.6 59.4-59.4 59.4s-59.4-26.6-59.4-59.4 26.6-59.4 59.4-59.4c32.8.1 59.3 26.6 59.4 59.4"
  })));
};
export default SvgGenderSignFemale;